import type {CutForestMass, UploadForestMass, WeightInventoryPlot} from '@/domain/entities/Op';
import type {UploadForestMassDto} from './OpDto';

export const uploadForestMassMapper = {
  toDto: (domain: UploadForestMass): UploadForestMassDto => ({
    ...domain,
    plannedCuttingDate: domain.plannedCuttingDate.toISOString(),
  }),
};

export const weightInventoryPlotMapper = {
  toDto: (domain: WeightInventoryPlot): WeightInventoryPlot => ({
    ...domain,
    appraiserWeight: domain.appraiserWeight * 1000,
  }),
};

export const cutForestMassMapper = {
  toDto: (domain: CutForestMass): CutForestMass => ({
    ...domain,
    realWeight: domain.realWeight * 1000,
  }),
};
